import './NumberDropdown.css';
import React, { useRef, useState } from 'react';
import { get } from '../../utils';
import { removeQueryString, default as addQueryString, deleteQueryString } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';

// let facetFilters: any = convertQueryParamsToFacets(queryParams);

const useDebounce = (value, timeout) => {
  const [state, setState] = React.useState(value);
  React.useEffect(() => {
    const handler = setTimeout(() => setState(value), timeout);
    return () => clearTimeout(handler);
  }, [value, timeout]);
  return state;
};
const NumberDropdown = _ref => {
  let {
    fields,
    hideLabel,
    hideAmount,
    dictionary,
    showLabel,
    selectAllLabel,
    resultsLabel,
    clearAllLabel,
    buttonYellow,
    openWithWrapper,
    keepOpenOnChange,
    widgetAnalytics,
    nbHits,
    setFilter,
    facetsName,
    indexDropDown,
    firstQuery,
    firstFilter,
    wrapperToggle,
    hideDesktopShowButton,
    hideShowButton,
    setSubpanelLabel,
    onChangeCallback,
    onToggleCallback,
    clearAlllFilters,
    analytics,
    getFilterValue,
    resetAllFiltersCallback,
    columnsClass = 'col-md-4'
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const [isOpen, setisOpen] = React.useState(false);
  const label = get(fields, 'title.jss.value');
  const selectedTagsToDisplay = get(fields, 'preselectedTags.values') || [];
  const [inputValue, setInputValue] = React.useState('');
  const debouncedInput = useDebounce(inputValue, 500);
  let history = useHistory();
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const rootRef = useRef();
  const [highLightText, setHighLightText] = useState(false);
  const clickedTextRef = useRef(false);
  const clearFilter = e => {
    setisOpen(false);
    setFilter();
    wrapperToggle(true, false);
    removeQueryString(facetsName, history);
    setInputValue('');
    getFilterValue && getFilterValue(fields.name, facetsName, null);
    if (e) {
      e.stopPropagation();
    }
  };
  React.useEffect(() => {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
        addQueryString(facetsName, preselectedTags.join(','), history);
        setFilter();
        resetAllFiltersCallback();
      } else {
        clearFilter();
      }
    }
  }, [clearAlllFilters]);
  const submitFilters = facetsName => {
    setFilter(true);
    if (!keepOpenOnChange) {
      setisOpen(false);
    }
    if (inputValue) {
      addQueryString(facetsName, `>= ${inputValue}`, history);
      getFilterValue && getFilterValue(fields.name, facetsName, `>= ${inputValue}`);
    } else {
      deleteQueryString(facetsName, history);
      getFilterValue && getFilterValue(fields.name, facetsName, null);
    }
  };
  const closeDropdwn = event => {
    if (event.target.closest) {
      if (event.target.closest('.filter__field') !== rootRef.current && !event.target.closest('.filter__header')) {
        setisOpen(false);
        wrapperToggle(true);
      } else if (event.target.closest('.filter__header-links')) {
        setisOpen(false);
        wrapperToggle(true);
      }
    } else {
      setisOpen(false);
      wrapperToggle(true);
    }
  };
  const onChangeInput = event => {
    setInputValue(event.target.value);
  };
  const handleTextMousedown = () => {
    clickedTextRef.current = true;
  };
  const handleTextFocus = () => {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  const handleTextBlur = () => {
    clickedTextRef.current = false;
    setHighLightText(false);
  };
  React.useEffect(() => {
    submitFilters(facetsName);
  }, [debouncedInput]);
  React.useEffect(() => {
    const queries = queryParams[`${filterType}`];
    if (!queries && selectedTagsToDisplay.length) {
      const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      addQueryString(facetsName, preselectedTags.join(','), history);
      setFilter(true);
    }
    document.body.addEventListener('click', closeDropdwn);
    return () => {
      removeQueryString(facetsName, history);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field number-dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    className: `
              input-text-primary
              input-search-text
              ${highLightText ? 'input-text-primary--focused' : ''}
            `,
    placeholder: label,
    type: "text",
    value: inputValue,
    onChange: onChangeInput,
    onMouseDown: handleTextMousedown,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur
  }))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    columnsClass
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${columnsClass}`
  }, children);
};

// export default NumberDropdown;
export default NumberDropdown;
const commonStyles = "c1sxb6v1";